<script setup lang="ts">
import { LinkIcon } from '@heroicons/vue/24/outline'
import Modal from '@/components/common/layout/Modal.vue'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'
import SaveButton from '@/components/common/buttons/SaveButton.vue'
import { useToast } from 'vue-toast-notification'
import { ref } from 'vue'
import SearchPartnerInput from '@/components/features/partners/SearchPartnerInput.vue'
import type { ParentAttributionDto } from '@/api-swagger'
import { usePartnerStore } from '@/stores/usePartnerStore'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
const route = useRoute()
const partnerId: number | null = parseInt(route.params.partnerId as string)

const partnerStore = usePartnerStore()
const { loading } = storeToRefs(partnerStore)
const props = defineProps({
  child: {
    type: Boolean,
    default: false,
  },
})

const $toast = useToast()
const parentAttributionModal = ref<boolean>(false)
const errors = ref<Record<string, string>>({})
const attribution = ref<ParentAttributionDto>({ parentId: 0 })

const openModal = () => {
  parentAttributionModal.value = true
}
const closeModal = () => {
  parentAttributionModal.value = false
  attribution.value = { parentId: 0 }
  errors.value = {}
}

const onSubmit = async () => {
  if (attribution.value) {
    let childId = partnerId

    if (props.child && attribution.value.parentId) {
      childId = attribution.value.parentId
      attribution.value.parentId = partnerId
    }
    await partnerStore
      .attributionParent(childId, attribution.value)
      .then(() => {
        $toast.success('Mise a jour effectuée')
        closeModal()
      })
      .catch((error: { message: string }) => {
        $toast.error(error.message)
      })
  }
}
</script>

<template>
  <slot name="trigger" :openModal="openModal">
    <ButtonDaisy text="Lier" :icon="LinkIcon" variant="secondary" @click="openModal" />
  </slot>
  <Modal
    :showModal="parentAttributionModal"
    @close="closeModal"
    :title="'Attribution Société ' + (child ? 'Enfant' : 'Mère')"
    :loading="loading"
    maxWidth="xl"
    overflowY="visible"
  >
    <template #content>
      <form @submit.prevent="" class="space-y-4 text-left">
        <div class="flex gap-2">
          <SearchPartnerInput
            v-model="attribution.parentId"
            :errorMessage="errors.parentId"
            class="w-full"
          />
        </div>
        <SaveButton @save="onSubmit" :loading="loading" />
      </form>
    </template>
  </Modal>
</template>
